import { render, staticRenderFns } from "./AIComposer.vue?vue&type=template&id=942b4a16&scoped=true&"
import script from "./AIComposer.vue?vue&type=script&lang=js&"
export * from "./AIComposer.vue?vue&type=script&lang=js&"
import style0 from "./AIComposer.vue?vue&type=style&index=0&id=942b4a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942b4a16",
  null
  
)

export default component.exports